import { CreateGMWTask, EditGMWTask } from "@nens/brostar/uploadapi-client";
import { SchemaForFormData } from "@nens/shared-utils";

import { pickGmwLibraryFields } from "../../../schema/gmw-schema-library";

import { geoOhmCableSchema } from "./gmw-geo-ohm-cable-schema";
/**
 * Schema for monitoring tube within GMW registration
 */
export const monitoringTubeSchema = {
  type: "array",
  title: "Monitoringsbuis",
  minItems: 0,
  maxItems: 50,
  items: {
    type: "object",
    title: "Monitoringsbuis",
    required: [
      "tubeNumber",
      "tubeType",
      "artesianWellCapPresent",
      "sedimentSumpPresent",
      "numberOfGeoOhmCables",
      "variableDiameter",
      "tubeStatus",
      "tubeTopPosition",
      "tubeTopPositioningMethod",
      "tubePackingMaterial",
      "tubeMaterial",
      "glue",
      "screenLength",
      "sockMaterial",
      "plainTubePartLength",
    ],
    properties: {
      ...pickGmwLibraryFields([
        "tubeNumber",
        "tubeType",
        "artesianWellCapPresent",
        "sedimentSumpPresent",
        "numberOfGeoOhmCables",
        "tubeTopDiameter",
        "variableDiameter",
        "tubeStatus",
        "tubeTopPosition",
        "tubeTopPositioningMethod",
        "tubePackingMaterial",
        "tubeMaterial",
        "glue",
        "screenLength",
        "sockMaterial",
        "screenProtection",
        "plainTubePartLength",
        "sedimentSumpLength",
      ]),
      geoOhmCables: geoOhmCableSchema,
    },
  },
} satisfies SchemaForFormData<
  (CreateGMWTask | EditGMWTask)["sourcedocumentData"]["monitoringTubes"]
>;
